import React, { type FC } from 'react'
import { Typography } from '../ui/Typography'
import { colors } from '../styles/colors'
import { styled } from '@linaria/react'
import ArrowUpRight from '../svgr/ArrowUpRight'
import { generateExplorerLink } from '../shared/utils/generateExplorerLink'
import { useTonConnect } from '../hooks/useTonConnect'

export const TransactionLink: FC<{
  transactionId: string
}> = ({ transactionId }) => {
  const { network } = useTonConnect()

  return (
    <Transaction
      href={generateExplorerLink(transactionId, network)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Typography fontSize={14} fontWeight={700} color={colors.grey700}>
        <TransactionId>{transactionId}</TransactionId>
      </Typography>
      <ArrowUpRight />
    </Transaction>
  )
}

const Transaction = styled.a`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  svg {
    width: 16px;
    height: 16px;
    color: ${colors.secondary};
  }
`

const TransactionId = styled.span`
  display: inline-block;
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
